import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SystemErrorData } from '../models/systemErrorData.model';

const INITIALIZE_DATA: SystemErrorData = {
  messageId: '',
  message: '',
  errorDetail: '',
}

/**
 * システムエラー画面サービス
 * @export
 * @class SystemErrorDataService
 */
@Injectable({
  providedIn: 'root'
})
export class SystemErrorDataService {
  /**
   * システムエラー画面表示データ
   * @type {SystemErrorData}
   * @memberof SystemErrorDataService
   */
  _systemErrorData$: BehaviorSubject<SystemErrorData> = new BehaviorSubject<SystemErrorData>({});

  /**
   * システムエラー画面データのobservable提供
   *
   * @readonly
   * @memberof SystemErrorDataService
   */
  get valueChange(): Observable<SystemErrorData> {
    return this._systemErrorData$.asObservable();
  }

  /**
   * システムエラー画面データ設定
   *
   * @type {void}
   * @memberof SystemErrorDataService
   */
  set systemErrorData(data: SystemErrorData) {
    this._systemErrorData$.next(data);
  }

  /**
   * コンストラクタ
   * @memberof SystemErrorDataService
   */
  constructor() {
    this.initializeData();
  }

  /**
   * オブジェクト破棄処理
   * @memberof SystemErrorDataService
   */
  ngOnDestroy() {
    
  }

  /**
   * 画面表示データ初期化
   * 完了画面のngOnDestroy()で呼び出す
   * @memberof SystemErrorDataService
   */
  public initializeData() {
    this._systemErrorData$.next(INITIALIZE_DATA);
  }

}
